/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-06-29 11:16:34
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-08 14:11:42
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  notification,
  Row,
  Select,
  Space,
} from 'antd'
import React, {
  forwardRef,
  ReactElement,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from './patientList.module.css'
import { AGColumns, Columns } from './columns'
import { RootDispatch } from '../../../../app/store'
import { DownOutlined, FilterOutlined, SearchOutlined } from '@ant-design/icons'
import { useHistory } from 'react-router-dom'
import { PatientGroupModal } from '../components/group'
import { PatientPanel } from '../patientPanel/patientPanel'
import {
  getCounselor,
  getMessageCount,
  getPatientOptionsAsync,
  selectSendIDs,
  setSendIDs,
} from '../../toothHome/toothHomeSlice'
import {
  getPatientByGroupAsync,
  getPatientGroupAsync,
  getPatientListExportAsync,
  removePatientAsync,
  selectAttendingDoctorList,
  selectCounselorList,
  setAttendingDoctorList,
  setCounselorList,
  setGroupList,
} from '../patientSlice'
import { MergePatientModal } from '../../../patient/list/mergePatientModal'
import { SendMessageModal } from '../../toothHome/modal/sendMessageModal'
import { SubscribeModal } from '../../toothHome/modal/subscribeModal'
import { RegisteredModal } from '../../toothHome/modal/registeredModal'
import {
  DateRangeFieldName,
  DateRangeType,
  DateSelect,
  ToothDay,
} from '../../../../compnents/form/DateSelect'
import { PurchaseModal } from '../../../patient/list/patientImportModal'
import { selectRole } from '../../../../app/applicationSlice'
import { getPageColumnListAsync, getSubmitPageColumnListAsync } from '../../../transactionQuery/transactionQuerySlice'
import { getSortColumnList } from '../../../../models/common'
import SimpleAgGrid from '../../../../compnents/simpleTable/SimpleAgGrid'
import { FilterColumn } from '../../../../compnents/filterForm/filterForm'
import { SJQXChecks } from '../../../../models/dataPersion'
import { getCheckPermissionAsync } from '../../../FunctionSetting/dataPermission/dataPermissionSlice'
interface PatientListsProps {
  groupId?: number
  refreshFlag?: number
  HZGLCKHZSJHData?: boolean
  HZGLCKHZSFZHData?: boolean
}

export interface PatientListsRef {
  refresh: () => void
}

const PatientLists = (
  { groupId, refreshFlag, HZGLCKHZSJHData, HZGLCKHZSFZHData}: PatientListsProps,
  ref: React.Ref<PatientListsRef>
): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const history = useHistory()

  const [form] = Form.useForm()

  const gridRef = useRef<any>(null);

  const [pageSelections, setPageSelections] = useState<Record<string, any[]>>({})

  // 所有的列表
  const listData: any = [
    {
      headerName: '',
      field: 'checkbox',
      checkboxSelection: true,
      headerCheckboxSelection: true,  // 启用表头复选框（全选功能）
      width: 60,
      minWidth: 60,
      pinned: 'left',// 将列固定在左侧
      lockPosition: "left", // 锁定列位置，防止列移动
      suppressMovable: true, // 防止列被拖动
      resizable: false, //防止列宽被调整
      visible: true,
    },
    {
      headerName: '序号',
      width: 80,
      minWidth: 80,
      field: 'index',
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '患者姓名',
      field: 'name',
      width: 200,
      minWidth: 200,
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '病历号',
      field: 'patientId',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '星级',
      field: 'star',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '性别',
      field: 'sex',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '年龄',
      field: 'ageYear',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '手机号',
      field: 'phone',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '介绍人',
      field: 'introducer',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '咨询师',
      field: 'counselor',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '患者分组',
      field: 'groupItemVos',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '患者来源',
      field: 'patientSource',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '就诊项目',
      field: 'treatmentItem',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '主治医生',
      field: 'attendingDoctor',
      align: 'center',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '创建时间',
      field: 'createTime',
      minWidth: 190,
      visible: true,
      sortable: true,
    },
    {
      headerName: '最近一次挂号时间',
      field: 'registrationTime',
      width: 200,
      minWidth: 200,
      sortable: true,
      pinned: 'right',
      lockPosition: "right",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '操作',
      field: 'action',
      width: 220,
      minWidth: 220,
      pinned: 'right',
      lockPosition: "right",
      suppressMovable: true,
      visible: true,
    },
  ]?.map((v,index)=>{
    return {
      ...v,
      index: index + 1,
    }
  })

  const allData = listData

  // 默认要展示的列的值
  const selectColumns = allData?.filter((v: any) => v.visible)?.map((item: any) => item.field) || []

  const [allColumnList, setAllColumnList] = useState<any[]>([]) //筛选列所有的数据

  // 筛选列所有的数据
  const [filterColumnList, setFilterColumnList] = useState<any[]>([])

  const [filterSelectList, setFilterSelectList] = useState<any[]>([]) //筛选列所有的数据

  const attendingDoctorList = useSelector(selectAttendingDoctorList)

  const counselorList = useSelector(selectCounselorList)

  const role = useSelector(selectRole)

  const [loading, setLoading] = useState(false)

  const [sortedInfo, setSorter] = useState<any>()

  const [params, setParams] = useState<any>({
    current: 1,
    size: 20,
  })

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })

  // const [selectIds, setSelectIds] = useState<any>([])
  const selectedKeys = useSelector(selectSendIDs)

  const [PatientGroupModalType, setPatientGroupModalType] = useState(0)

  const [groupVisible, setGroupVisible] = useState(false)

  const [currentId, setCurrentId] = useState('')

  const [currentPatientId, setCurrentPatientId] = useState('')

  const [mergePatientVisible, setMergePatientVisible] = useState(false)

  const [sendMessageModal, setSendMessageModal] = useState(false) // 发送短信弹窗

  const [sendMsgObj, setSendMsgObj] = useState<any>(null)

  const [subscribeModal, setSubscribeModal] = useState(false) // 工作站-预约弹窗

  const [tablePppointmentId, setTablePppointmentId] = useState('') //  表格预约 ID

  const [tableRegistrationId, setTableRegistrationId] = useState('') //  表格挂号 ID

  const [tableTreatmentDoctorId, setTableTreatmentDoctorId] = useState('') //  表格=预约-就诊医生 ID

  const [registeredModal, setRegisteredModal] = useState(false) //工作站-挂号弹窗

  const [isPurchaseModalVisible, setIsPurchaseModalVisible] = useState(false) // 控制导入弹窗是否显示

  const [purchaseModalState, setPurchaseModalState] = useState<number>() //模板弹窗导入模板控制

  const [classificationList, setClassificationList] = useState<any>() //就诊项目数据

  const [exportloading, setExportloading] = useState(false)

  useEffect(() => {
    if (JSON.stringify(pageSelections) != '{}') {
      const derivedSelectedKeys = Object.values(pageSelections).flat()
      dispatch(setSendIDs(derivedSelectedKeys || []));
    }
  }, [pageSelections])

  useEffect(() => {
    if (!selectedKeys?.length) {
      setPageSelections({})
    }
  }, [selectedKeys]);

  useImperativeHandle(ref, () => ({
    refresh: () => {
      getPage(true)
    },
  }))

  useEffect(() => {
    dispatch(
      getCounselor({
        current: 1,
        size: 100,
        stationCategory: 1,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        dispatch(
          setAttendingDoctorList(
            res?.records
              ?.filter((v: any) => v.kssxbz != 1)
              .filter((v: any) => v.state == 1)
          )
        )
      })
    dispatch(
      getCounselor({
        current: 1,
        size: 100,
        stationCategory: 4,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        dispatch(
          setCounselorList(
            res?.records
              ?.filter((v: any) => v.kssxbz != 1)
              .filter((v: any) => v.state == 1)
          )
        )
      })
    dispatch(getMessageCount())
    return () => {
      dispatch(setSendIDs([]))
    }
  }, [])

  const getPage = (flag = false) => {
    setLoading(true)
    dispatch(
      getPatientByGroupAsync({
        ...params,
        current: flag ? 1 : params.current,
        groupId,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        const data = {
          total: res.total,
          items: res.records,
        }
        setPage(data)
        // setSelectIds([])
        // dispatch(setSendIDs([]))
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    getPage()
    getPageColumnList()
  }, [params])

  useEffect(() => {
    getPage(true)
    setCurrentId('')
    setParams({
      ...params,
      current: 1,
    })
  }, [groupId, refreshFlag])

  // useImperativeHandle(ref, () => ({
  //   reload: () => {
  //     dispatch(getPaymentList(params))
  //   },
  // }))

  const disable = (callback: () => void) => {
    if (selectedKeys?.length == 0) {
      notification.info({
        message: '请先选择患者',
      })
      return
    }
    callback()
  }

  const menu = (
    <Menu>
      <Menu.Item
        onClick={() => {
          disable(() => {
            setSendMsgObj(null)
            setSendMessageModal(true)
          })
        }}
      >
        发送短信
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          disable(() => {
            setPatientGroupModalType(4)
            setGroupVisible(true)
          })
        }}
      >
        患者交接
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          disable(() => {
            setPatientGroupModalType(3)
            setGroupVisible(true)
          })
        }}
      >
        加入分组
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          disable(() => {
            setPatientGroupModalType(5)
            setGroupVisible(true)
          })
        }}
      >
        更改分组
      </Menu.Item>
    </Menu>
  )

  const submitPageList = (data: any) => {
    const params = {
      pageName: 'toothPatientList',
      configJson: JSON.stringify(data),
    }
    dispatch(getSubmitPageColumnListAsync({
      ...params,
    }))
      .then(unwrapResult)
      .then((v: any) => {
        getPageColumnList(v?.id)
      })
  }

  const getPageColumnList = (id?: any) => {
    dispatch(getPageColumnListAsync({
      id: id ? id : undefined,
      pageName: 'toothPatientList',
    }))
      .then(unwrapResult)
      .then((v: any) => {
        const data: any = v?.configJson ? JSON.parse(v?.configJson) : []
        const filterList = data?.filter((n: any) => n?.visible)
        const columns = filterList?.map((n: any) => n?.field)
        const resetData = data?.map(((v: any) => {
          const sameFileds = allData?.find((item: any) => item?.field == v?.field)
          return {
            ...v,
            minWidth: sameFileds?.minWidth || v?.minWidth,
            width: sameFileds?.width || v?.width,
            headerName: sameFileds?.headerName || v?.headerName,
          }
        }))
        // 所有的数据
        setAllColumnList(data?.length ? resetData : allData)
        // 筛选后存在后端的数据
        setFilterColumnList(filterList?.length ? filterList : allData)
        // 选中的值
        setFilterSelectList(columns?.length ? columns : selectColumns)
      })
      .catch(() => {
        setAllColumnList(allData)
        setFilterColumnList(allData)
        setFilterSelectList(selectColumns)
      })
      .finally(() => {
        setLoading(false)
      })
  }


  const importTemplateFn = (state: number) => {
    // 导入模板
    setPurchaseModalState(state)
    setIsPurchaseModalVisible(true)
  }

  const outCluedExport = () => {
    setExportloading(true)
    dispatch(getPatientListExportAsync({ ...params }))
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '患者管理.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        notification.success({
          message: '导出失败',
          duration: 3,
        })
      })
      .finally(() => {
        setExportloading(false)
      })
  }


  useEffect(() => {
    if (
      sortedInfo?.order === 'ascend' &&
      sortedInfo?.columnKey === 'createTime'
    ) {
      setParams({
        ...params,
        createTimeSort: 0,
        registrationTimeSort: undefined,
        nameSort: undefined,
        patientIdSort: undefined,
      })
    } else if (
      sortedInfo?.order === 'descend' &&
      sortedInfo?.columnKey === 'createTime'
    ) {
      setParams({
        ...params,
        createTimeSort: 1,
        registrationTimeSort: undefined,
        nameSort: undefined,
        patientIdSort: undefined,
      })
    } else if (
      sortedInfo?.order === 'ascend' &&
      sortedInfo?.columnKey === 'registrationTime'
    ) {
      setParams({
        ...params,
        registrationTimeSort: 0,
        createTimeSort: undefined,
        nameSort: undefined,
        patientIdSort: undefined,
      })
    } else if (
      sortedInfo?.order === 'descend' &&
      sortedInfo?.columnKey === 'registrationTime'
    ) {
      setParams({
        ...params,
        registrationTimeSort: 1,
        createTimeSort: undefined,
        nameSort: undefined,
        patientIdSort: undefined,
      })
    } else if (
      sortedInfo?.order === 'ascend' &&
      sortedInfo?.columnKey === 'name'
    ) {
      setParams({
        ...params,
        nameSort: 0,
        createTimeSort: undefined,
        registrationTimeSort: undefined,
        patientIdSort: undefined,
      })
    } else if (
      sortedInfo?.order === 'descend' &&
      sortedInfo?.columnKey === 'name'
    ) {
      setParams({
        ...params,
        nameSort: 1,
        createTimeSort: undefined,
        registrationTimeSort: undefined,
        patientIdSort: undefined,
      })
    } else if (
      sortedInfo?.order === 'ascend' &&
      sortedInfo?.columnKey === 'patientId'
    ) {
      setParams({
        ...params,
        patientIdSort: 0,
        createTimeSort: undefined,
        registrationTimeSort: undefined,
        nameSort: undefined,
      })
    } else if (
      sortedInfo?.order === 'descend' &&
      sortedInfo?.columnKey === 'patientId'
    ) {
      setParams({
        ...params,
        patientIdSort: 1,
        createTimeSort: undefined,
        registrationTimeSort: undefined,
        nameSort: undefined,
      })
    }
  }, [sortedInfo])

  useEffect(() => {
    dispatch(getPatientOptionsAsync({ types: '0,1,2' }))
      .then(unwrapResult)
      .then((res: any) => {
        const findItems = (type: string) => {
          return res ? res?.find((t: any) => t.type == type)?.items?.map((v: any) => {
            return {
              name: v.context,
              value: v.sortNo,
            }
          }) : []
        }
        setClassificationList({
          sourceList: findItems('1'),
          treatmentItemList: findItems('2'),
        })
      })
  }, [])

  return (
    <Col
      style={{
        height: '100%',
      }}
    >
      {currentId ? (
        <PatientPanel
          HZGLCKHZSJHData={HZGLCKHZSJHData}
          HZGLCKHZSFZHData={HZGLCKHZSFZHData}
          editGroupId={currentId}
          appointmentId={tablePppointmentId} //预约 ID
          patientId={currentId}
          backID={currentId}
          backCall={() => {
            setCurrentId('')
          }}
        />
      ) : (
        <div className={styles.main}>
          <Form
            form={form}
            onFinish={(values) => {
              setParams({
                ...params,
                ...values,
                current: 1,
                registrationTimeHead: undefined,
                registrationTimeTail: undefined,
                registEndTime: values.registrationTimeTail,
                registStartTime: values.registrationTimeHead,
              })
            }}
          >
            <Row
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <div style={{ marginBottom: '9.6px', display: 'flex', flexWrap: 'wrap' }}>
                <Form.Item name='key' noStyle>
                  <Input
                    autoComplete='off'
                    prefix={<SearchOutlined />}
                    placeholder='患者姓名/助记码/手机号/病历号'
                    allowClear
                    onChange={form.submit}
                    style={{
                      width: '258px',
                      marginLeft: '2px',
                      marginRight: '6px',
                    }}
                  />
                </Form.Item>
                <Form.Item name='attendingDoctorId' noStyle>
                  <Select
                    placeholder='主治医生'
                    allowClear
                    style={{ width: '7em', marginRight: '6px' }}
                    onChange={form.submit}
                    showSearch
                    filterOption={(input, option: any) =>
                      (option?.children ?? '')
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {attendingDoctorList.map((d) => (
                      <Select.Option key={d.id} value={d.id}>
                        {d.realname}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item name='counselorId' noStyle>
                  <Select
                    placeholder='咨询师'
                    allowClear
                    showSearch
                    style={{ width: '6em', marginRight: '6px' }}
                    onChange={form.submit}
                    filterOption={(input, option: any) =>
                      (option?.children ?? '')
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {counselorList.map((d) => (
                      <Select.Option key={d.id} value={d.id}>
                        {d.realname}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item name='treatmentItem' noStyle>
                  <Select
                    placeholder='就诊项目'
                    allowClear
                    style={{ width: '7em', marginRight: '6px' }}
                    onChange={form.submit}
                  >
                    {classificationList?.treatmentItemList?.map((d: any) => (
                      <Select.Option key={d.name} value={d.name}>
                        {d.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <DateSelect
                  placeholder='最近一次挂号'
                  style={{ width: '8rem', marginRight: '6px' }}
                  onChange={form.submit}
                  labelPrefix=''
                  namePrefix='registrationTime'
                />
                <Form.Item name='introducer' noStyle>
                  <Input
                    autoComplete='off'
                    placeholder='介绍人'
                    allowClear
                    style={{
                      width: '6rem',
                      marginRight: '6px',
                    }}
                  />
                </Form.Item>
                <Form.Item name='patientSource' noStyle>
                  <Select
                    placeholder='患者来源'
                    allowClear
                    style={{ width: '7em', marginRight: '6px' }}
                    onChange={form.submit}
                  >
                    {classificationList?.sourceList.map((v: any) => {
                      return (
                        <Select.Option key={v.name} value={v.name}>
                          {v.name}
                        </Select.Option>
                      )
                    })}
                  </Select>
                </Form.Item>
                <Button type='primary' size='middle' htmlType='submit' loading={loading}>
                  查询
                </Button>
                <FilterColumn
                  filterColumn={allColumnList}
                  filterSelectList={filterSelectList}
                  // 筛选列变化时的数据
                  onColumnVisibilityChange={(v: any) => {
                    setLoading(true)
                    // 以 allColumnList 的顺序为基准，用 v 中的字段顺序重排，并保留 allColumnList 的 visible 状态
                    const sortList = allColumnList?.map((val) => {
                      return {
                        ...val,
                        visible: v?.includes(val.field)
                      }
                    })
                    submitPageList(sortList)
                    setAllColumnList(sortList)
                  }}
                />
              </div>
              <div style={{ marginBottom: '10px' }}>
                <Button
                  type='primary'
                  size='middle'
                  style={{
                    backgroundColor: '#FFB841',
                    borderColor: '#FFB841',
                    marginRight: '6px',
                  }}
                  onClick={() => {
                    history.push('/toothPatient/label')
                  }}
                >
                  标签设置
                </Button>
                <Dropdown overlay={menu} trigger={['click']}>
                  <Button
                    size='middle'
                    style={{ marginRight: '6px' }}
                    type='primary'
                    className={styles.add}
                    disabled={selectedKeys?.length == 0}
                  >
                    批量操作
                    <DownOutlined />
                  </Button>
                </Dropdown>
                <Button type='primary' size='middle' loading={exportloading} style={{ marginRight: '6px' }} onClick={() => {
                  if (role == 1) {
                    outCluedExport()
                  } else {
                    notification.info({
                      message: '非管理员不支持导出，请联系管理员导出',
                    })
                  }
                }}>
                  导出患者
                </Button>
                <Button type='primary' size='middle' onClick={() => importTemplateFn(1)}>
                  导入患者
                </Button>
              </div>
            </Row>
          </Form>
          <SimpleAgGrid
            page={{
              current: params?.current || 1,
              size: params?.size || 10,
              total: page?.total,
              items: page?.items,
            }}
            column={(AGColumns(
              params?.size * (params?.current - 1),
              (action, t) => {
                setCurrentPatientId(t.patient.id)
                setTablePppointmentId(t.registration.appointmentId)
                if (action == 'merge') {
                  setMergePatientVisible(true)
                } else if (action == 'delete') {
                  dispatch(
                    removePatientAsync({
                      ids: [t.patient.id].toString(),
                    })
                  )
                    .then(unwrapResult)
                    .then(() => {
                      notification.success({
                        message: '删除成功',
                      })
                      dispatch(getPatientGroupAsync())
                        .then(unwrapResult)
                        .then((res: any) => {
                          dispatch(setGroupList(res.records))
                          getPage()
                        })
                    })
                } else if (action == 'message') {
                  const data = {
                    name: t.patient.name,
                    sex: t.patient.sex,
                    ageYear: t.patient.ageYear,
                    phone: t.patient.phone,
                    id: t.patient.id,
                  }
                  dispatch(setSendIDs([]))
                  setSendMsgObj(data)
                  setSendMessageModal(true)
                } else if (action == 'appointment') {
                  setSubscribeModal(true)
                } else if (action == 'registration') {
                  setRegisteredModal(true)
                }
              },
              allColumnList,
              HZGLCKHZSJHData,
            ))?.filter((item: any) => filterSelectList?.includes(item.field))}
            isLoading={loading}
            pagination={true}
            pageKey={'toothPatientList'}
            rowSelection="multiple"
            selectedRowKeys={selectedKeys}
            getRowId={(data: any) => data.patient?.id?.toString()}
            onRowDoubleClick={(event: any) => {
              const r = event?.data
              setCurrentId(r.patient.id)
              setTablePppointmentId(r.registration.appointmentId)
            }}
            onSelectionChange={(selectedRows: any, selectedNodes: any) => {
              const selectedRowIds = selectedRows.map((row: any) => row.patient?.id?.toString())
              // 更新当前页面的选中状态
              const currentPage = params.current;
              setPageSelections((prev: any) => {
                // 当前页数据的 id 集合：用于区分“被搜索挤出的旧选中”与“用户主动取消”
                const currentPageDataIds = new Set(
                  (page?.items || []).map((row: any) => row?.patient?.id?.toString())
                );
                const prevCurrentPageIds = prev?.[currentPage] || [];
                const keepIds = prevCurrentPageIds.filter(
                  (id: any) => !currentPageDataIds.has(id)
                );
                return {
                  ...prev,
                  [currentPage]: [...keepIds, ...(selectedRowIds || [])],
                };
              });
            }}
            suppressRowClickSelection={true}
            // 配置底部行样式
            getRowStyle={(params) => {
              if (params.node.rowPinned) {
                return {
                  fontWeight: 'normal',
                  backgroundColor: '#D9F2FF',
                };
              }
              return {}; // 将返回 null 改为返回空对象，避免类型不匹配问题
            }}
            onChangePage={(current: any, size: any) => {
              setParams({
                ...params,
                current,
                size,
              })
              setPage({
                ...page,
                current,
                size,
              })
            }}
            onColumnResized={(v: any) => {
              return
            }}
            onColumnMoved={(v) => {
              // setPageLoading(true)
              const sortList = getSortColumnList(allColumnList, v);
              submitPageList(sortList)
              setAllColumnList(sortList)
            }}
            onSortChanged={(sortModel, hasComparator) => {
              if (hasComparator) {
                console.log("sortModel", page?.items, sortModel, hasComparator)
              } else {
                if (sortModel && sortModel.length > 0) {
                  setSorter(sortModel?.[0])
                } else {
                  setParams({
                    ...params,
                    createTimeSort: undefined,
                    registrationTimeSort: undefined,
                    nameSort: undefined,
                    patientIdSort: undefined,
                  })
                }
              }
            }}
            sortedInfo={sortedInfo ? [sortedInfo] : []}
          />
          {/* <EditableList
            bordered
            loading={loading}
            scroll={{ x: 1550 }}
            sticky
            className={styles.table}
            rowKey={(v, i) => {
              return `${v.patient.id}`
            }}
           
            columns={Columns(
              params.size * (params.current - 1),
            
              sortedInfo
            )}
            onChange={(a, b, sorter: any) => {
              setSorter(sorter)
            }}
            onChangePage={(current, size) =>
              setParams({
                ...params,
                current,
                size: size || 20,
              })
            }
            onRow={(r) => ({
              onDoubleClick: () => {
                setCurrentId(r.patient.id)
                setTablePppointmentId(r.registration.appointmentId)
              },
              // onClick: () => {
              //   let data = []
              //   if (!selectedKeys.includes(r.id.toString())) {
              //     data = [r.id.toString(), ...selectedKeys]
              //   } else {
              //     data = selectedKeys.filter(v => v != r.id.toString())
              //   }
              //   dispatch(setSendIDs(data))
              // }
            })}
            rowSelection={{
              selectedRowKeys: selectedKeys,
              onSelectAll: (
                selected: any,
                selectedRows: any,
                changeRows: any
              ) => {
                let data: any = []
                if (selected) {
                  data = [
                    ...changeRows.map((v: any) => v.patient.id.toString()),
                    ...selectedKeys,
                  ]
                } else {
                  data = selectedKeys.filter(
                    (item) =>
                      !changeRows.some(
                        (ele: any) => ele.patient.id.toString() === item
                      )
                  )
                }
                dispatch(setSendIDs(data))
              },
              onSelect: (record, selected, selectedRows) => {
                let data = []
                if (selected) {
                  data = [record.patient.id.toString(), ...selectedKeys]
                } else {
                  data = selectedKeys.filter(
                    (v) => v != record.patient.id.toString()
                  )
                }
                dispatch(setSendIDs(data))
              },
            }}
          /> */}
        </div>
      )}

      <PatientGroupModal
        type={PatientGroupModalType}
        visible={groupVisible}
        onCancel={() => {
          setGroupVisible(false)
          dispatch(setSendIDs([]))
        }}
        patientIds={selectedKeys}
        onOk={() => {
          setGroupVisible(false)
          getPage()
        }}
      />

      <MergePatientModal
        patientId={currentPatientId}
        visible={mergePatientVisible}
        onCancel={() => setMergePatientVisible(false)}
        onOk={() => {
          getPage()
        }}
        type={2}
      />

      <SendMessageModal
        HZGLCKHZSJHData={HZGLCKHZSJHData}
        isBirthday={true}
        sendMsgObj={sendMsgObj}
        visible={sendMessageModal}
        onCancel={() => {
          setSendMsgObj(null)
          setSendMessageModal(false)
          dispatch(setSendIDs([]))
        }}
        onOk={() => {
          setSendMsgObj(null)
          // getTableList()
        }}
      />

      {/* 工作站-预约 */}
      <SubscribeModal
        visible={subscribeModal}
        patientId={currentPatientId} //患者 ID
        appointmentId={tablePppointmentId} //预约 ID
        registrationId={tableRegistrationId} //挂号 ID
        treatmentDoctorId={tableTreatmentDoctorId} //就诊医生 ID
        onOk={() => {
          setSubscribeModal(false)
          setParams({ ...params, current: 1 })
        }}
        onCancel={() => setSubscribeModal(false)}
      />

      {/* 工作站-挂号 */}
      <RegisteredModal
        title={0}
        patientId={currentPatientId}
        appointmentId={tablePppointmentId} //预约 ID
        registrationId={tableRegistrationId} //挂号 ID
        visible={registeredModal}
        onOk={() => {
          setRegisteredModal(false)
          setParams({ ...params, current: 1 })
        }}
        onCancel={() => {
          setRegisteredModal(false)
        }}
      />
      <PurchaseModal
        state={purchaseModalState}
        isPurchaseModalVisible={isPurchaseModalVisible}
        onOk={() => {
          setIsPurchaseModalVisible(false)
          getPage()
        }}
        onCancel={() => {
          setIsPurchaseModalVisible(false)
          getPage()
        }}
      />
    </Col>
  )
}

export const PatientList = forwardRef(PatientLists)

